import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';
import AdCardCompact from '../components/ads/AdCardCompact';

const CategoryAdsPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [ads, setAds] = useState<any[]>([]);
  const [categoryName, setCategoryName] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const catRes = await api.get('/categories');
        const categories = catRes.data.data || [];
        const category = categories.find((c: any) => c.slug === slug);

        if (category) {
          setCategoryName(category.name_ar);
          const adsRes = await api.get('/ads', {
            params: { category_id: category.id, page: currentPage },
          });
          const data = adsRes.data.data;
          setAds(data?.ads || []);
          setCurrentPage(data?.pagination?.current_page || 1);
          setLastPage(data?.pagination?.last_page || 1);
          setTotal(data?.pagination?.total || 0);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, currentPage]);

  return (
    <div className="max-w-site mx-auto px-4 py-6">
      <div className="flex items-center gap-2 text-sm text-gray-400 mb-4">
        <Link to="/" className="hover:text-primary-500">الرئيسية</Link>
        <span>/</span>
        <Link to="/categories" className="hover:text-primary-500">التصنيفات</Link>
        <span>/</span>
        <span className="text-gray-600">{categoryName}</span>
      </div>

      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">{categoryName}</h1>
          <p className="text-sm text-gray-500 mt-1">{total} إعلان</p>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="text-gray-400">جاري التحميل...</div>
        </div>
      ) : ads.length === 0 ? (
        <div className="bg-white rounded-xl p-12 text-center shadow-sm">
          <p className="text-gray-400 text-lg">لا توجد إعلانات في هذا التصنيف</p>
        </div>
      ) : (
        <>
          <div className="ajc-list">
            {ads.map((ad) => (
              <AdCardCompact key={ad.id} ad={ad} />
            ))}
          </div>

          {lastPage > 1 && (
            <div className="flex justify-center gap-2 mt-8">
              <button
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-white rounded-lg shadow-sm text-sm disabled:opacity-50"
              >
                السابق
              </button>
              <span className="px-4 py-2 bg-primary-500 text-white rounded-lg text-sm">
                {currentPage} / {lastPage}
              </span>
              <button
                onClick={() => setCurrentPage((p) => Math.min(lastPage, p + 1))}
                disabled={currentPage === lastPage}
                className="px-4 py-2 bg-white rounded-lg shadow-sm text-sm disabled:opacity-50"
              >
                التالي
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CategoryAdsPage;
